import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

function AddSubadmin() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !password) {
      return toast.error(t("addSubadmin.error.fillAllFields"));
    }

    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}admin/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ name, email, password }),
      });

      const result = await res.json();
      if (result.code === 200 || result.code === 201) {
        toast.success(result.message || t("addSubadmin.success.added"));
        navigate("/all-subadmins");
      } else {
        toast.error(result.message || t("addSubadmin.error.failed"));
      }
    } catch (err) {
      console.error(err);
      toast.error(t("addSubadmin.error.somethingWentWrong"));
    } finally {
      setLoading(false);
    }

    setName("");
    setEmail("");
    setPassword("");
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        {t("addSubadmin.title")}
      </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t("addSubadmin.labels.name")}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t("addSubadmin.labels.email")}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label={t("addSubadmin.labels.password")}
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Button type="submit" variant="contained" disabled={loading}>
              {loading
                ? t("addSubadmin.buttons.adding")
                : t("addSubadmin.buttons.add")}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}

export default AddSubadmin;
